import { render, staticRenderFns } from "./ModalReject.vue?vue&type=template&id=298fd934&scoped=true&"
import script from "./ModalReject.vue?vue&type=script&lang=js&"
export * from "./ModalReject.vue?vue&type=script&lang=js&"
import style0 from "./ModalReject.vue?vue&type=style&index=0&id=298fd934&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298fd934",
  null
  
)

export default component.exports